export const routes = {
    "/documents": {
        title: "Documents & Links",
        authorise: true,
    }
};
